import { useQuery } from "react-query";
import { useRouter } from "../../useRouter";
import { useApiError } from "src/hooks/useApiError";
import { getUnregisterBill } from "src/service/pay";
import { useState } from "react";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { useRecoilState } from "recoil";
import { userInfoAtom } from "src/atoms";

interface IUseTotalNxacListProps {
  // billType: "PAY" | "PROMOTION";
  enabled?: boolean;
  onSuccess?: (serviceList: any) => void;
  onError?: () => void;
}
// Bill페이지 에서 사용할 구매이력 정보
export function useGetPayUnregisterBill({
  // billType,
  enabled = true,
  onSuccess,
  onError,
}: IUseTotalNxacListProps) {
  const { handleError } = useApiError();
  const { goConsole } = useRouter();
  const [isAvailable, setIsAvailable] = useState<boolean>(false);
  const [userInfo] = useRecoilState(userInfoAtom);
  const route = useRouter();
  // 내가 구매한 요금제 정보
  const {
    isLoading,
    isSuccess,
    data: unregisterPayList,
  } = useQuery(
    [`getPayUnregisterBill-${getProductFromSessionStorage()}`],
    async () =>
      await getUnregisterBill({
        billType: "PAY",
        product: getProductFromSessionStorage(),
      }),
    {
      refetchOnMount: true, // 컴포넌트가 마운트될 때마다 쿼리를 리페치할지 여부를 나타내는 플래그
      refetchOnWindowFocus: true, // 윈도우가 포커스를 받을 때마다 쿼리를 리페치할지 여부를 나타내는 플래그
      keepPreviousData: true,
      enabled:
        enabled &&
        getProductFromSessionStorage() !== null &&
        // ["WRAPSODY", "WRAPSODY_ECO", "DSP", "FIRESIDE"].includes(
        //   getProductFromSessionStorage()
        // ) &&
        userInfo.userId !== "",
      onSuccess: onSuccess ? onSuccess : (res) => {},
      onError: handleError,
    }
  );

  return { isLoading, isSuccess, unregisterPayList: unregisterPayList };
}
